<style type="text/css">
.dateTime {
  width: auto !important;
}

.dateTime .field-input {
  color: rgb(0, 168, 255) !important;
  padding: 2px !important;
  font-size: 12px !important;
  border: 0 !important;
}

.reset {
  display: flex;
  padding-top: 1em;
  padding-left: 0.5em;
}

.close-custom {
  font-size: 15px;
  transform: translateY(-50%);
}

.dateTime input::placeholder {
  color: rgb(0, 168, 255) !important;
  font-weight: 400;
}

.dynamic-actions {
  font-weight: bolder;
  width: 2em;
}

.form-select {
  width: 160px;
  height: 2em;
  font-size: small;
}

.action-dropdown-toggle {
  background: none !important;
  border: none !important;
  font-weight: 400 !important;
  color: #00a8ff !important;
  padding: 2px !important;
  font-size: 12px !important;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

</style>
<template>
  <div class="dateTime position-relative">
    <div>
      <div class="d-flex align-items-center">
        <select v-if="this.mode !== this.OLD_RECORD_MODE" class="form-select" v-model="mode" @change="changeMode()">
          <option :value="FIXED_MODE">{{lang.fixed_date}}</option>
          <option :value="DYNAMIC_MODE">{{lang.current_date}}</option>
          <option v-if="dateFields.length > 0 || sourceDateFields.length > 0" :value="OLD_RECORD_MODE">{{lang.map_source_record}}</option>
        </select>
        <div v-if="actionType === 'create_record' && this.mode === this.OLD_RECORD_MODE" class="dropdown action-tab-select-down d-flex align-items-center">
          <input
              class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
              type="button"
              v-bind:value="selectedFieldLabel"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              v-on:click.stop.prevent="activeDropdown = !activeDropdown"
          />
          <div class="popup-container-main" v-if="activeDropdown">
            <div class="popup-container popup-container-modify">
              <div class="popup-search-filter">
                <div class="workflow-selected-field">
                  <span>{{lang.select + ' ' + lang.value}}</span>
                </div>
              </div>
              <div class="workflow-accordion-container-modify-record" v-click-outside="closeDropdown">
                <div class="accordion" :id="'accordionAutomationDate-' + mapping_for.id">
                  <div class="card">
                    <div class="card-header automation-card-header" :id="'headingNewRecordDate-' + mapping_for.id">
                      <p class="mb-0 automation-accordion-p">
                        <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                                v-bind:data-target="'#collapseNewRecordDate-' + mapping_for.id" aria-expanded="true"
                                v-bind:aria-controls="'collapseNewRecordDate-' + mapping_for.id">
                          {{table}}
                        </button>
                      </p>
                    </div>
                    <div :id="'collapseNewRecordDate-' + mapping_for.id" class="collapse show"
                         v-bind:aria-labelledby="'headingNewRecordDate-' + mapping_for.id"
                         v-bind:data-parent="'#accordionAutomationDate-' + mapping_for.id">
                      <div class="card-body">
                        <div class="workflow-row-details">
                          <ul>
                            <li v-for="field in dateFields" :key="field.id" @click="selectField(field, 'new')">
                              <a v-bind:class="{ active: selectedRecordType === 'new' && selectedFieldId === field.id }" href="javascript:void(0)">{{field.label}}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card" v-if="sourceDateFields.length > 0">
                    <div class="card-header automation-card-header" :id="'headingSourceRecordDate-' + mapping_for.id">
                      <p class="mb-0 automation-accordion-p">
                        <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                                v-bind:data-target="'#collapseSourceRecordDate-' + mapping_for.id" aria-expanded="false"
                                v-bind:aria-controls="'collapseSourceRecordDate-' + mapping_for.id">
                          {{sourceTable}}
                        </button>
                      </p>
                    </div>
                    <div :id="'collapseSourceRecordDate-' + mapping_for.id" class="collapse"
                         v-bind:aria-labelledby="'headingSourceRecordDate-' + mapping_for.id"
                         v-bind:data-parent="'#accordionAutomationDate-' + mapping_for.id">
                      <div class="card-body">
                        <div class="workflow-row-details">
                          <ul>
                            <li v-for="field in sourceDateFields" :key="field.id" @click="selectField(field, 'source')">
                              <a v-bind:class="{ active: selectedRecordType === 'source' && selectedFieldId === field.id }" href="javascript:void(0)">{{field.label}}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card" v-if="showOldRecord !== false">
                    <div class="card-header automation-card-header" :id="'headingOldRecordDate-' + mapping_for.id">
                      <p class="mb-0 automation-accordion-p">
                        <button class="btn btn-link automation-accordion-btn" type="button" data-toggle="collapse"
                                v-bind:data-target="'#collapseOldRecordDate-' + mapping_for.id" aria-expanded="false"
                                v-bind:aria-controls="'collapseOldRecordDate-' + mapping_for.id">
                          {{table}} {{lang.old}} {{lang.record}}
                        </button>
                      </p>
                    </div>
                    <div :id="'collapseOldRecordDate-' + mapping_for.id" class="collapse"
                         v-bind:aria-labelledby="'headingOldRecordDate-' + mapping_for.id"
                         v-bind:data-parent="'#accordionAutomationDate-' + mapping_for.id">
                      <div class="card-body">
                        <div class="workflow-row-details">
                          <ul>
                            <li v-for="field in dateFields" :key="field.id" @click="selectField(field, 'old')">
                              <a v-bind:class="{ active: selectedRecordType === 'old' && selectedFieldId === field.id }" href="javascript:void(0)">{{lang.old}}{{lang.record}}.{{field.label}}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="reset">
          <button class="close close-custom" @click="reset">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div v-if="actionType === 'create_record' && this.mode === this.DYNAMIC_MODE">
        <b-input-group size="sm" class="mb-1">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">{{lang.days}}</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalDays"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalDays')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalDays')">+</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group size="sm" class="mb-1" v-if="withTime">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">Hours</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalHours"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalHours')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalHours')">+</b-button>
          </b-input-group-append>
        </b-input-group>
        <b-input-group size="sm" class="mb-1" v-if="withTime">
          <b-input-group-prepend>
            <span class="input-group-text" id="inputGroup-sizing-default">Minutes</span>
          </b-input-group-prepend>
          <b-form-input id="additional-days-input" type="number" v-model="dynamicDate.additionalMinutes"></b-form-input>
          <b-input-group-append>
            <b-button class="input-group-text dynamic-actions" @click="decrementDynamicDate('additionalMinutes')">-</b-button>
            <b-button class="input-group-text dynamic-actions" @click="incrementDynamicDate('additionalMinutes')">+</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div v-if="actionType === 'create_record' && this.mode === this.FIXED_MODE" class="px-3">
        <VueCtkDateTimePicker
          :format="withTime ? setDynamicFormat() + ' HH:mm' : setDynamicFormat()"
          :formatted="withTime ? setDynamicFormat() + ' HH:mm' : setDynamicFormat()"
          v-model="dateTime"
          :no-label="true"
          :locale="lang.code"
          :button-now-translation="lang.now"
          :noClearButton="true"
          :label="lang.select + ' ' + lang.value"
          :only-date="!withTime"
          :position="'bottom'"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'level', // advanced condition level
    'mapping_for',
    'type',
    'field_type',
    'custom',
    'CreateRecordMapping',
    'actionType',
    'Auth',
    'lang',
    'fields', // fields of the table that triggered the automation (old record)
    'table', // label of the table that triggered the automation (old record)
    'showOldRecord', // false hides the "old record" group (e.g. secondary create record has no old record)
    'sourceFields', // optional: fields of the table that triggered the automation (record_type 'source')
    'sourceTable', // optional: label of the table that triggered the automation
  ],
  data() {
    return {
      DYNAMIC_MODE: 'DYNAMIC_MODE',
      FIXED_MODE: 'FIXED_MODE',
      OLD_RECORD_MODE: 'OLD_RECORD_MODE',
      mode: 'FIXED_MODE',
      withTime: false,
      dynamicDate: {
        additionalDays: 0,
        additionalHours: 0,
        additionalMinutes: 0,
      },
      previousDate: null,
      selectedFieldId: null,
      selectedRecordType: null,
      activeDropdown: false,
      dateType: null,
      typesWithTime: ['datetime', 'datetimeDynamic'],
      dynamicTypes: ['dateDynamic', 'datetimeDynamic'],
      dateFieldTypes: ['date', 'datetime'],
    }
  },
  mounted() {

  },
  created() {
    this.withTime = this.typesWithTime.includes(this.mapping_for.type);
    this.dateType = this.withTime ? 'datetimeDynamic' : 'dateDynamic';
    if (this.mapping_for.field_type_dd !== undefined && this.mapping_for.field_type_dd !== null && this.mapping_for.field_type_dd !== '') {
      this.dateType = this.mapping_for.field_type_dd;
    }
    this.getMappedValue();
  },
  computed: {
    dateTime: {
      get() {
        return this.getMappedValue();
      },
      set(newVal) {
        this.getDateTime(newVal);
      }
    },
    dateFields() {
      if (!this.fields) {
        return [];
      }
      return this.fields.filter(field => this.dateFieldTypes.includes(field.field_type));
    },
    sourceDateFields() {
      if (!this.sourceFields) {
        return [];
      }
      return this.sourceFields.filter(field => this.dateFieldTypes.includes(field.field_type));
    },
    selectedFieldLabel() {
      let field = (this.selectedRecordType === 'source' ? this.sourceDateFields : this.dateFields)
        .find(x => x.id === this.selectedFieldId);
      if (!field) {
        return this.lang.select + ' ' + this.lang.value;
      }
      if (this.selectedRecordType === 'old') {
        return this.lang.old + this.lang.record + '.' + field.label;
      }
      return field.label;
    }
  },
  beforeMount() {

  },
  methods: {
    getDateTime(val) {
      if (val !== undefined) {
        let label = this.mode === this.DYNAMIC_MODE ? `Current date` : val;
        if (this.mode === this.FIXED_MODE) {
          this.previousDate = val;
        }
        let data = {
          mapping_for: {...this.mapping_for, type: this.dateType},
          selected_field: {
            'name': val,
            'label': label,
            'id': null,
            'field_type_dd': this.dateType,
          },
          record_type: 'custom',
        };

        this.$emit('CreateRecordOptionSelectedEvent', data);
      }
    },
    getMappedValue() {
      let dateTimeDetails = null;
      if (this.CreateRecordMapping.length > 0) {
        let _index = this.CreateRecordMapping.findIndex(x => x.mapping_for_id === this.mapping_for.id);
        let currentFieldMapping = this.mapping_for;
        if (_index > -1) {
          currentFieldMapping = this.CreateRecordMapping[_index];
          dateTimeDetails = this.CreateRecordMapping[_index].mapped_with_name;
        }
        if (_index > -1 && ['old', 'new', 'source'].includes(currentFieldMapping.record_type)) {
          this.mode = this.OLD_RECORD_MODE;
          this.selectedFieldId = currentFieldMapping.mapped_with_id;
          this.selectedRecordType = currentFieldMapping.record_type;
          return dateTimeDetails;
        }
        this.dateType = currentFieldMapping.field_type_dd ? currentFieldMapping.field_type_dd : currentFieldMapping.type;
        this.withTime = this.typesWithTime.includes(this.dateType);
        this.mode = this.dynamicTypes.includes(this.dateType) ? this.DYNAMIC_MODE : this.FIXED_MODE;
        if (this.mode === this.DYNAMIC_MODE) {
          this.dynamicDate = dateTimeDetails;
        } else {
          this.previousDate = dateTimeDetails;
        }
      }
      return dateTimeDetails;
    },
    closeDropdown() {
      this.activeDropdown = false;
    },
    selectField(field, recordType) {
      this.mode = this.OLD_RECORD_MODE;
      this.selectedFieldId = field.id;
      this.selectedRecordType = recordType;
      this.activeDropdown = false;
      let data = {
        mapping_for: {...this.mapping_for, type: this.dateType},
        selected_field: {
          'name': field.name,
          'label': field.label,
          'id': field.id,
          'field_type_dd': field.field_type,
        },
        record_type: recordType,
      };

      this.$emit('CreateRecordOptionSelectedEvent', data);
    },
    setDynamicFormat() {
      switch (this.Auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setDateSeparator(format) {
      if (this.Auth.formatting.date_separator) {
        let _separator = this.Auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    },
    incrementDynamicDate (parameter) {
      if (this.dynamicDate[parameter] !== undefined) {
        this.dynamicDate[parameter] = +this.dynamicDate[parameter] + 1;
        this.getDateTime(this.dynamicDate);
      }
    },
    decrementDynamicDate (parameter) {
      if (this.dynamicDate[parameter] !== undefined) {
        this.dynamicDate[parameter] = +this.dynamicDate[parameter] - 1;
        this.getDateTime(this.dynamicDate);
      }
    },
    changeMode () {
      if (this.mode === this.DYNAMIC_MODE) {
        this.dateType = this.withTime ? 'datetimeDynamic' : 'dateDynamic';
        this.getDateTime(this.dynamicDate);
      } else if (this.mode === this.OLD_RECORD_MODE) {
        this.selectedFieldId = null;
        this.selectedRecordType = null;
      } else {
        this.dateType = this.withTime ? 'datetime' : 'date';
        this.getDateTime(this.previousDate);
      }
    },
    reset() {
      this.mode = this.DYNAMIC_MODE;
      this.dynamicDate = {
        additionalDays: 0,
        additionalHours: 0,
        additionalMinutes: 0,
      };
      this.previousDate = null;
      this.selectedFieldId = null;
      this.selectedRecordType = null;
      this.activeDropdown = false;
      this.$emit('removeSelectedItemEvent');
    }
  }
}
</script>
